// extracted by mini-css-extract-plugin
var _1 = "sXSlB";
var _2 = "BD04b";
export { _1 as "loadMoreIconBrand", _2 as "loadMoreNodeState" }
